import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

interface IPayment {
  applicant_payment_id: number;
  vat_num: string;
  quarter_id: number;
  quarter: string;
  year: number;
  submission_date: string;
  total_vat_amount_payable: number;
  amount: number;
  payment_date: string;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IPaymentListOutput {
  items: IPayment[];
  paging: IPaging;
}

interface IPaymentListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  schemeType?: string;
}

export const fetchPaymentList = async (
  payload: IPaymentListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) {
    searchQuery += `&vat_num=${payload.vat_num}`;
  }
  if (payload.schemeType) {
    searchQuery += `&schemeType=${payload.schemeType}`;
  }
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/payment/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: IPaymentListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const paymentInfo = async (): Promise<Types.ResponseOutput> => {
  const data: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/payment/info`
  );
  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

interface IPaymentInfo {
  payment_info_id: number;
  country_id: number;
  country: string;
  amount_received: number;
}

interface IPaymentInfoListOutput {
  items: IPaymentInfo[];
  paging: IPaging;
}

interface IPaymentInfoListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  paymentRef?: string;
  schemeType?: string;
  msconCountry?: string;
}

export const fetchPaymentInfoList = async (
  payload: IPaymentInfoListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.paymentRef) {
    searchQuery += `&paymentRef=${payload.paymentRef}`;
  }
  if (payload.schemeType) {
    searchQuery += `&schemeType=${payload.schemeType}`;
  }
  if (payload.msconCountry) {
    searchQuery += `&msconCountry=${payload.msconCountry}`;
  }
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/payment/info/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: IPaymentInfoListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IUpdatePaymentInfoReferenceInput {
  // payment_reference: string;
  payment_date: Date;
  payment_info_id: number;
}
export const updatePaymentInfoReference = async (
  payload: IUpdatePaymentInfoReferenceInput
) => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/payment/info/${payload.payment_info_id}`,
    {
      // payment_reference: payload.payment_reference,
      payment_date: payload.payment_date,
    }
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
